import { render, staticRenderFns } from "./DailyCheckCommentHistory.vue?vue&type=template&id=e9675140&"
import script from "./DailyCheckCommentHistory.vue?vue&type=script&lang=js&"
export * from "./DailyCheckCommentHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports